import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=5c65bfb5"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=5c65bfb5&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c65bfb5')) {
      api.createRecord('5c65bfb5', component.options)
    } else {
      api.reload('5c65bfb5', component.options)
    }
    module.hot.accept("./Group.vue?vue&type=template&id=5c65bfb5", function () {
      api.rerender('5c65bfb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/price/pricingChange/Group.vue"
export default component.exports